<template>
  <div
    :class="{
      'micro-front-end-container': true,
      'mfe-error': error,
    }"
  >
    <slot v-if="!error" />
    <div v-else>
      <!-- should we use an MFE error page instead of 404? -->
      <FourOhFour />
    </div>
  </div>
</template>

<script>
export default {
  name: 'MfeBase',
  props: {
    error: {
      type: Boolean,
      required: true
    }
  }
}
</script>

<style lang='scss'>
.micro-front-end-container {
  height: 100%;
  width: 100%;
}

.micro-front-end-container .loading.circle {
  width: 90% !important;
}
</style>
